import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

export interface DateDisplay {
    year: string;
    month: string;
    day: string;
}

export const CUSTOM_DATE_FORMATS = {
    parse: {
        dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
    },
    display: {
        dateInput: 'customInput',
        monthYearLabel: { year: 'numeric', month: 'short' },
        dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    },
};

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
    override parse(value: string): Date | null {
        try {
            let date: Date = null;
            if (this.locale === 'fr') {
                // format: dd/MM/yyyy
                const [day, month, year] = value.split('/');
                date = new Date(+year, +month - 1, +day);
            } else {
                date = new Date(value);
            }
            return date;
        } catch (error) {
            console.log('format erreur');
            return null;
        }
    }

    override format(date: Date, display: string | DateDisplay): string {
        if (display === 'customInput') {
            return new DatePipe(this.locale).transform(date, 'shortDate');
        } else {
            return new DatePipe(this.locale).transform(date, 'MMM yyyy');
        }
    }

    override getFirstDayOfWeek(): number {
        return 1;
    }
}
